module.exports = __webpack_public_path__ + "img/stock_saleoff.2d2a848f.png";